export const errorHandler = {
    throwNotFound() {
        return 'Failed to Connect to Server (Url Not Found)!';
    },

    throwTimeOut() {
        return 'Connection Time Out!';
    },

    tomcatError(err, isSweetalert = false, title = undefined,) {
        let response = err.response;
        let errorMessage;
        if (response) {
            console.error(response)
            if (response.status === 404) {
                errorMessage = this.throwNotFound();
            }else if (response.status === 500) {
                let serverError = response.data;
                if (typeof serverError === 'object') {
                    serverError = serverError.message || serverError.error || serverError.Error ||
                        serverError.response_message || JSON.stringify(serverError);
                }
                return Swal.fire({
                    title: 'An Error Occurred',
                    icon: `error`,
                    html : `<p>Please Contact Support : +260958168829</p><span>${serverError}</span>`,
                    showCloseButton : true,
                })
            }else {
                errorMessage = response.data;
                if (errorMessage.error && typeof errorMessage === 'object') {
                    errorMessage = errorMessage.error;
                } else if (errorMessage.Error && typeof errorMessage === 'object') {
                    errorMessage = errorMessage.Error;
                } else if (errorMessage.response_message && typeof errorMessage === 'object') {
                    errorMessage = errorMessage.response_message;
                } else if (errorMessage.message && typeof errorMessage === 'object') {
                    errorMessage = errorMessage.message;
                } else if (errorMessage.Print && errorMessage.Print.toString().contains('failed')) {
                    errorMessage = errorMessage.Print;
                }
            }
        } else if (err.code === `ECONNABORTED`) {
            errorMessage = this.throwTimeOut()
        } else {
            console.error(err)
            errorMessage = err.message;
        }
        if (errorMessage === `Network Error`) {
            title = title ? title : errorMessage;
            errorMessage = `Please Check your Internet`;
        }
        if (typeof errorMessage === 'object') {
            errorMessage = errorMessage.response;
            if (errorMessage.error && typeof errorMessage === 'object') {
                errorMessage = errorMessage.error;
            } else if (errorMessage.Error && typeof errorMessage === 'object') {
                errorMessage = errorMessage.Error;
            } else if (errorMessage.response_message && typeof errorMessage === 'object') {
                errorMessage = errorMessage.response_message;
            } else if (errorMessage.message && typeof errorMessage === 'object') {
                errorMessage = errorMessage.message;
            }else if (errorMessage.Message && typeof errorMessage === 'object') {
                errorMessage = errorMessage.Message;
            } else if (errorMessage.Print && errorMessage.Print.toString().contains('failed')) {
                errorMessage = errorMessage.Print;
            }
        }
        if (!isSweetalert) {
            responses.throwErr(errorMessage, title);
        }
        throw new Error(errorMessage);
    },

    /**
     * Pure mapper for /api/v1/delivery/login errors. Returns a structured
     * object so callers can render an inline message and fire a toast.
     * Does NOT touch window.*, responses.*, or Swal — those are the
     * caller's job. Does NOT throw.
     *
     * See docs/superpowers/specs/2026-08-04-stock-dispatch-login-error-ux-design.md §6.
     */
    loginError(err) {
        const response = err && err.response;
        const status = response ? response.status : null;
        let body = response ? response.data : null;
        if (typeof body === 'object' && body !== null) {
            body = body.message || body.error || body.Error || body.response_message || body.Message || null;
        }
        const rawMessage = (body != null ? String(body) : (err && err.message) || 'Unknown error').trim();
        console.error('[loginError]', { status, rawMessage });

        // 1) Body-string match first — two 400s need different copy.
        const bodyMatchers = [
            { test: (s) => /local\s*id\s+is\s+required/i.test(s), msg: "Something went wrong on our side. Please try again or contact support." },
            { test: (s) => /invalid\s+dispatch\s+id/i.test(s),     msg: "This dispatch slip is no longer valid. Please request a new one from dispatch." },
            { test: (s) => /not\s+at\s+right\s+stage/i.test(s),    msg: "This dispatch isn't ready for collection yet. Please check back later or contact dispatch." },
            { test: (s) => /invalid\s+dispatch\s+type/i.test(s),  msg: "This dispatch is set up incorrectly. Please contact dispatch." },
            { test: (s) => /invalid\s+pin/i.test(s),               msg: "Wrong PIN. Please try again." },
        ];
        for (const m of bodyMatchers) {
            if (m.test(rawMessage)) {
                return { httpStatus: status, friendlyMessage: m.msg, rawMessage };
            }
        }

        // 2) HTTP status-code fallback.
        const byStatus = {
            400: "Please check the details and try again.",
            403: "Access denied. Please contact dispatch.",
            404: "Service not found. Please try again or contact support.",
            409: "Conflict. Please contact dispatch.",
        };
        if (status && byStatus[status]) {
            return { httpStatus: status, friendlyMessage: byStatus[status], rawMessage };
        }
        if (status && status >= 500) {
            return { httpStatus: status, friendlyMessage: "Something went wrong on our side. Please try again or contact support.", rawMessage };
        }

        // 3) Network / no response.
        if (!response) {
            return { httpStatus: null, friendlyMessage: "Please check your internet connection and try again.", rawMessage };
        }

        // 4) Unknown — return the raw string honestly.
        return { httpStatus: status, friendlyMessage: rawMessage || "An unexpected error occurred.", rawMessage };
    },
}